import React from 'react';

export default class NavBar extends React.Component<any, any> {
  render() {
    return (
      <header id="header" className="fixed-top header-scrolled">
        <div className="container d-flex align-items-center justify-content-lg-between">
          <img src={'assets/logo-w.png'} width={180} alt={'logo'} />
          <nav id="navbar" className="navbar order-last order-lg-0">
            <ul>
              <li>
                <a className="nav-link scrollto active" href="#hero">
                  Home
                </a>
              </li>
              <li>
                <a className="nav-link scrollto" href="#about">
                  About
                </a>
              </li>
              <li>
                <a className="nav-link scrollto" href="#services">
                  Services
                </a>
              </li>
              <li>
                <a className="nav-link scrollto" href="#contact">
                  Contact
                </a>
              </li>
            </ul>
            {/*<i className="bi bi-list mobile-nav-toggle"></i>*/}
          </nav>
          <div>&nbsp;</div>
          {/*<a href="#about" className="get-started-btn scrollto">Get Started</a>*/}
        </div>
      </header>
    );
  }
}
